import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PochtaLocation } from './PochtaLocation'
import { OrderCdekDeliveryTimes } from './OrderCdekDeliveryTimes'
/**
* Class OrderDeliveryMethodPochtaDto
*  Специфика доставки Почта России (ОПС).
*/
export class OrderDeliveryMethodPochtaDto extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Pochta' })
  readonly kind: string = 'Pochta'


  /**
  * to
  * ОПС назначения.  */
  @ActiveField({
    factory: [PochtaLocation, () => undefined]
  })
  to?: PochtaLocation


  /**
  * times
  * Сроки доставки (калькулятор + Extra*).  */
  @ActiveField({
    factory: [OrderCdekDeliveryTimes, () => undefined]
  })
  times?: null | OrderCdekDeliveryTimes


/**
  * barcode
  * ШПИ (штриховой почтовый идентификатор), ключ трекинга.
  */
  @ActiveField()
  barcode?: null | string
}
